import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punenearbyattraction() {



    const cardData =
    {
        keyword: 'Pune Nearby Attractions',
        heading: 'Anand Krushi Paryatan Kendra: Pune Nearby Attractions',
        headingDescription: 'Looking to explore Pune nearby attractions during your stay or weekend getaway? Pune is surrounded by a diverse range of scenic and cultural destinations perfect for one-day trips or short vacations. From the historic forts of Sinhagad, Lohagad, and Shivneri to the serene landscapes of Mulshi Dam, Panshet Lake, and Pawna Lake, there’s something for every traveler. Nature lovers can visit Bhigwan Bird Sanctuary, Rajmachi Point, or the lush Tamhini Ghat, while those seeking spiritual experiences will enjoy places like Alandi, Dehu, and Jejuri. For family-friendly fun, Morachi Chincholi, Imagicaa Theme Park, and Lavasa City are must-visits. Whether you are interested in trekking, photography, or rural tourism, Pune’s surroundings offer endless attractions for every season.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

        topPlaces: [
  {
    "title": "Sinhagad Fort",
    "description": "Located about 35 km from Pune, Sinhagad Fort is a historic hill fortress offering panoramic views, trekking trails, and a glimpse into Maratha history. It's especially popular among trekkers, nature lovers, and history enthusiasts seeking a day trip with a touch of adventure."
  },
  {
    "title": "Lavasa",
    "description": "A beautifully planned hill city around 60 km from Pune, Lavasa offers a mix of lakeside promenades, boating, nature trails, cafes, and colorful architecture. Ideal for romantic getaways or peaceful retreats in a European-inspired townscape."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 65–70 km away, the twin hill stations of Lonavala and Khandala are famous for scenic waterfalls, lush green valleys, Bhushi Dam, Rajmachi Point, and local chikki shops. A perfect monsoon escape or weekend drive from Pune."
  },
  {
    "title": "Mulshi Dam & Lake",
    "description": "Surrounded by the Sahyadri ranges, Mulshi is a tranquil destination known for its lake views, resorts, nature photography, and forest drives. Located around 50 km from Pune, it's ideal for relaxation and scenic beauty."
  },
  {
    "title": "Panshet Dam",
    "description": "About 40 km from Pune, Panshet is a peaceful getaway for boating, kayaking, and picnicking by the water. Surrounded by hills and greenery, it's a popular choice for couples, bikers, and nature lovers."
  },
  {
    "title": "Bhuleshwar Temple",
    "description": "An ancient and artistic Shiva temple located around 50 km from Pune, known for its unique Mughal-style architecture, mythological carvings, and peaceful ambiance. Ideal for spiritual seekers and architecture lovers."
  },
  {
    "title": "Rajgad Fort",
    "description": "Once the capital of Chhatrapati Shivaji Maharaj, Rajgad Fort lies around 60 km from Pune and offers a mix of historical exploration, overnight trekking, and panoramic Sahyadri views. It's a must-visit for trekking and Maratha history fans."
  },
  {
    "title": "Jejuri – Khandoba Temple",
    "description": "Famous for its turmeric-covered rituals and grand temple steps, Jejuri is one of Maharashtra’s most vibrant pilgrimage sites, just 50 km from Pune. Visit during festivals for a uniquely colorful experience."
  },
  {
    "title": "Pawna Lake",
    "description": "A beautiful lake near Lonavala, Pawna is famous for camping, barbeque nights, bonfires, and kayaking. With stunning views of forts like Lohagad and Tikona, it's a top pick for couples and weekend campers from Pune."
  },
  {
    "title": "Ranjangaon Mahaganpati Temple",
    "description": "One of the Ashtavinayak temples located 50 km from Pune, Ranjangaon Mahaganpati is a spiritually significant and beautifully built Ganesh temple, often visited on religious day-trips and festive tours."
  }
],




"services": [
  {
    "name": "Top Tourist Attractions Near Pune",
    "description": "Anand Krushi Paryatan Kendra is emerging as a top rural tourism attraction near Pune. Nestled amidst serene farmlands near Morachi Chincholi, it offers an authentic agri-tourism experience—complete with tractor rides, traditional cooking demos, and local folk art performances. Ideal for those who want to explore Maharashtra beyond the usual cityscape."
  },
  {
    "name": "Historical Places Near Pune",
    "description": "While not a historical site itself, Anand Krushi Paryatan Kendra lies close to several culturally significant forts and temples. It's a perfect base to explore iconic sites like Shivneri Fort or Jejuri Temple, and return to a relaxing rural retreat filled with age-old farming traditions and cultural storytelling around bonfires."
  },
  {
    "name": "Nature Spots Close to Pune",
    "description": "Immerse yourself in the greenery and quiet of Anand Krushi Paryatan Kendra—a hidden nature spot just a short drive from Pune. With open skies, orchards, and chirping birds all around, it's an ideal getaway for nature lovers looking to unplug and reconnect with the earth through hands-on farm life."
  },
  {
    "name": "Family-Friendly Attractions Near Pune",
    "description": "Anand Krushi Paryatan Kendra is one of the most family-friendly rural destinations near Pune. With safe play zones for children, animal feeding corners, bullock cart rides, and fresh local food, it offers an enriching day out for all ages, blending fun with meaningful interaction with nature and farming."
  },
  {
    "name": "Adventure Activities Near Pune",
    "description": "Looking for a dash of adventure near Pune? Anand Krushi Paryatan Kendra delivers with thrilling tractor rides, hands-on ploughing demos, and even rural obstacle games. Adventure meets tradition here, providing a unique experience unlike commercial resorts—grounded in the heart of countryside life."
  },
  {
    "name": "Weekend Sightseeing Near Pune",
    "description": "Plan a refreshing weekend escape to Anand Krushi Paryatan Kendra. With its tranquil farm setting, local food delicacies, peacock sightings, and proximity to Morachi Chincholi’s natural beauty, it makes for an ideal weekend sightseeing and cultural immersion experience—all within a short drive from Pune."
  },
  {
    "name": "Religious Places Near Pune",
    "description": "Combine spirituality with simplicity by visiting Anand Krushi Paryatan Kendra and nearby temples like Moreshwar Temple in Morgaon. The peaceful environment, morning chants, and rural hospitality make it a soulful stop in your spiritual journey around Pune."
  },
  {
    "name": "Museums and Galleries Near Pune",
    "description": "While Anand Krushi Paryatan Kendra is not a traditional museum, it serves as a living gallery of rural life. From farming tools and techniques to folk art and cultural displays, every corner reflects the agricultural heritage of Maharashtra—perfect for culturally curious visitors."
  },
  {
    "name": "Parks and Gardens Near Pune",
    "description": "Escape to the natural charm of Anand Krushi Paryatan Kendra, which feels like a living garden itself. Surrounded by orchards, native trees, flower beds, and vegetable plantations, it's an open-air paradise for those who enjoy the calm and beauty of green spaces."
  },
  {
    "name": "Popular Markets Near Pune",
    "description": "Just a short drive from Anand Krushi Paryatan Kendra, explore vibrant rural markets selling fresh produce, handmade goods, and local snacks. Back at the farm, guests can even participate in fruit-picking or buy homemade items like pickles, jaggery, and farm-fresh vegetables."
  },
  {
    "name": "Heritage Sites Near Pune",
    "description": "While Anand Krushi Paryatan Kendra focuses on rural culture, its location near heritage sites like Bhuleshwar Temple and Shivneri Fort makes it a great dual-destination getaway—blending history, tradition, and farm life into one enriching weekend trip."
  },
  {
    "name": "Entertainment Zones Near Pune",
    "description": "Tired of malls and gaming zones? Anand Krushi Paryatan Kendra offers a new kind of entertainment—farm games, folk dances, bonfire stories, and traditional Maharashtrian food. It’s interactive, wholesome fun in a peaceful setting just outside Pune."
  },
  {
    "name": "Cultural Centers Near Pune",
    "description": "Anand Krushi Paryatan Kendra serves as a live cultural center, showcasing rural traditions, native farming practices, and local customs. From folk songs to cooking on chulhas, it’s a deep dive into Maharashtra’s living heritage, ideal for students and culture enthusiasts."
  },
  {
    "name": "Wildlife Sanctuaries Near Pune",
    "description": "While not a wildlife sanctuary, Anand Krushi Paryatan Kendra offers a taste of natural biodiversity. Located near peacock-friendly Morachi Chincholi and surrounded by native flora and fauna, it's a calm and eco-aware space perfect for casual birdwatching and nature photography."
  },
  {
    "name": "Scenic Viewpoints Near Pune",
    "description": "Anand Krushi Paryatan Kendra offers more than just flat farmland—it features open landscapes, sunrise and sunset views, and panoramic rural horizons that are perfect for scenic photos, meditation, or just soaking in the beauty of the countryside."
  }
],
"tableData": [
  ["Top Tourist Attractions Near Pune", "- Historical Places Near Pune"],
  ["Nature Spots Close to Pune", "- Family-Friendly Attractions Near Pune"],
  ["Adventure Activities Near Pune", "- Weekend Sightseeing Near Pune"],
  ["Religious Places Near Pune", "- Museums and Galleries Near Pune"],
  ["Parks and Gardens Near Pune", "- Popular Markets Near Pune"],
  ["Heritage Sites Near Pune", "- Entertainment Zones Near Pune"],
  ["Cultural Centers Near Pune", "- Wildlife Sanctuaries Near Pune"],
  ["Scenic Viewpoints Near Pune", "- "]
],



        "whychoose": [
  {
    "WhyChooseheading": "Shaniwar Wada",
    "WhyChoosedescription": "A historic fort palace located in the heart of Pune, Shaniwar Wada was once the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture, historical importance, and the light and sound show in the evening, it’s a must-visit for history buffs."
  },
  {
    "WhyChooseheading": "Aga Khan Palace",
    "WhyChoosedescription": "Built in 1892, this serene palace is closely associated with Mahatma Gandhi's life and India’s freedom struggle. The beautifully maintained gardens and museum offer a peaceful and educational experience for all ages."
  },
  {
    "WhyChooseheading": "Sinhagad Fort",
    "WhyChoosedescription": "Located about 30 km from Pune, this historic hill fortress is a favorite for trekkers and nature lovers. The panoramic views from the top, local food stalls (like kanda bhaji and pithla bhakri), and historical ruins make it a perfect half-day adventure."
  },
  {
    "WhyChooseheading": "Mulshi Dam & Lake",
    "WhyChoosedescription": "Surrounded by lush greenery and the Sahyadri hills, Mulshi is a popular spot for monsoon getaways, picnics, and romantic retreats. Enjoy lakeside views, waterfalls, and eco-resorts for a tranquil escape from city life."
  },
  {
    "WhyChooseheading": "Lavasa City",
    "WhyChoosedescription": "A planned hill city around 60 km from Pune, Lavasa offers European-style architecture, lakeside promenades, adventure sports, and scenic drives. Ideal for couples and family weekend trips."
  },
  {
    "WhyChooseheading": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "WhyChoosedescription": "Home to over 100 species, including white tigers, leopards, elephants, and reptiles, this well-maintained zoo is great for kids and educational tours. The adjoining Katraj Lake adds to the natural ambiance."
  },
  {
    "WhyChooseheading": "Bhuleshwar Temple",
    "WhyChoosedescription": "Located around 50 km from Pune, this 13th-century Shiva temple is carved out of stone and features intricate carvings and panoramic views. It’s a peaceful and spiritual getaway ideal for early morning trips."
  },
  {
    "WhyChooseheading": "Panshet Dam",
    "WhyChoosedescription": "Another scenic dam located about 40 km from Pune, Panshet is popular for its water sports, boating, and nature views. It’s an excellent option for picnics, bike rides, and short family outings."
  }
]



    }

 const faqData = [
  {
    id: 'FAQ1',
    question: 'What makes Anand Krushi Paryatan Kendra a top nearby attraction from Pune?',
    answer: 'Located just 65 km from Pune in Morachi Chincholi, Anand Krushi offers a refreshing countryside experience with farm activities, nature trails, and rural charm—perfect for a short getaway.',
  },
  {
    id: 'FAQ2',
    question: 'Is it a good place for one-day picnics near Pune?',
    answer: 'Yes! Anand Krushi is ideal for one-day trips. It offers a complete picnic experience with nature, food, relaxation, and activities all in one place.',
  },
  {
    id: 'FAQ3',
    question: 'What are the top attractions within the premises?',
    answer: 'Visitors enjoy tractor rides, butterfly watching, bullock cart rides, rural games, nature walks, and shaded picnic spots surrounded by greenery.',
  },
  {
    id: 'FAQ4',
    question: 'How does it compare to other nearby tourist spots?',
    answer: 'Unlike commercial amusement parks, Anand Krushi provides a natural, educational, and culturally rich rural experience—calmer, greener, and more interactive.',
  },
  {
    id: 'FAQ5',
    question: 'Is Morachi Chincholi itself worth visiting?',
    answer: 'Absolutely. Morachi Chincholi is famous for its peacock sanctuary and agritourism centers like Anand Krushi. It’s serene, scenic, and full of natural beauty.',
  },
  {
    id: 'FAQ6',
    question: 'Can tourists explore nearby attractions while visiting Anand Krushi?',
    answer: 'Yes. Visitors can also explore the Morachi Chincholi peacock sanctuary and local temples nearby, making it a well-rounded rural tourism spot.',
  },
  {
    id: 'FAQ7',
    question: 'Is it suitable for senior citizens or large families?',
    answer: 'Yes. The peaceful ambiance, shaded resting areas, and gentle activities make it a pleasant spot for all age groups, including seniors.',
  },
  {
    id: 'FAQ8',
    question: 'Are there any photography opportunities?',
    answer: 'Definitely! The farm landscape, rural setups, animals, and peacocks offer excellent spots for nature and candid photography.',
  },
  {
    id: 'FAQ9',
    question: 'How to reach Anand Krushi from Pune?',
    answer: 'It is accessible by road via Alandi or Chakan, with clear signage once you enter Morachi Chincholi. Travel time is around 1.5 hours by car.',
  },
  {
    id: 'FAQ10',
    question: 'Is prior booking required during holidays?',
    answer: 'Yes, due to high footfall during weekends and holidays, it is advised to book in advance for a smooth experience and confirmed access to group activities.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Naik, Pune',
    feedback: "Anand Krushi is a hidden gem! So close to Pune yet so peaceful. The kids loved the farm animals and rides, and we were amazed by the number of peacocks. Highly recommended for families!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sneha Joshi, Travel Blogger',
    feedback: "Among all the Pune nearby attractions I’ve explored, Anand Krushi stood out for its authenticity. Real rural charm, clean environment, and warm hospitality. A perfect day escape!",
    rating: 5,
  },
];




    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Nearby Attractions",
  "image": "https://morachichincholi.in/assets/images/pune-nearby-attractions.jpg",
  "description": "Explore top attractions near Pune including historical sites, nature getaways, religious landmarks, and adventure spots. Anand Krushi Paryatan Kendra at Morachi Chincholi is the perfect hub for exploring these nearby destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "1892"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "0",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/pune-nearby-attractions"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune Nearby Attractions | Historical & Nature Spots | Anand Krushi Paryatan Kendra</title>
  <meta 
    name="description" 
    content="Discover top Pune nearby attractions including historical places, nature spots, temples, adventure zones, museums, and family-friendly getaways. Base your visit at Anand Krushi Paryatan Kendra in Morachi Chincholi." 
  />
  <meta 
    name="keywords" 
    content="Top tourist attractions near Pune, Historical places near Pune, Nature spots close to Pune, Family-friendly attractions near Pune, Adventure activities near Pune, Weekend sightseeing near Pune, Religious places near Pune, Museums and galleries near Pune, Parks and gardens near Pune, Popular markets near Pune, Heritage sites near Pune, Entertainment zones near Pune, Cultural centers near Pune, Wildlife sanctuaries near Pune, Scenic viewpoints near Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/2.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punenearbyattraction;